export default "__VITE_ASSET__8p7RBJZE__"